import React from 'react';
import { useMediaQuery } from '@material-ui/core';

import theme from 'MuiTheme';
import AdminEventCardTrimmed from 'components/eventCard/AdminEventCardTrimmed';
import { getBookingStatus, getTimeDuration, getTransferStatus } from 'pages/admin/events/utils/EventCardMapper';
import { BackendEvent, BookingStats } from 'queries/AdminEventQueries.types';

interface EventDisplayProps {
  event: BackendEvent;
  stats: BookingStats;
}

const EventDisplay: React.FC<EventDisplayProps> = ({ event, stats }) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <AdminEventCardTrimmed
      title={event.displayTitle}
      subtitle={getTimeDuration(event)}
      currentEventBooked={stats.countBooked}
      currentEventAttended={stats.countAttending}
      maxEventAttended={event.attendanceLimit}
      paidPeople={stats.countPaid}
      isMobile={isMobile}
      checks={[
        {
          label: 'Location',
          value: event.location,
          showStatus: false,
          isOk: false,
        },
        {
          label: 'Price',
          value: `${event.basePriceSek} SEK`,
          showStatus: false,
          isOk: false,
        },
        {
          ...getBookingStatus(event),
        },
        {
          ...getTransferStatus(event),
        },
      ]}
    />
  );
};

export default EventDisplay;
